import { createFileRoute, useLoaderData } from '@tanstack/react-router';
import { Iframe } from 'common/components/iframe/iframe';
import { validateGuardsOrRedirect } from 'common/guards';
import { getWorkatoIframeUrl, WORKATO_PATH } from 'services/workatoService';

const WorkatoIframe = () => {
  const { workatoIframeUrl } = useLoaderData({ from: '/spaces/external/integrations' });

  return <Iframe src={workatoIframeUrl} />;
};

export const Route = createFileRoute('/spaces/external/integrations')({
  beforeLoad: async ({ location }) => {
    await validateGuardsOrRedirect(location.state?.externalPayload?.guards ?? []);
  },
  validateSearch: (search: Record<string, unknown>) => ({
    workatoPath: search.workatoPath as string as WORKATO_PATH,
  }),
  loaderDeps: ({ search: { workatoPath } }) => ({ workatoPath }),
  loader: async ({ deps }) => {
    const { url } = await getWorkatoIframeUrl({ path: deps.workatoPath });

    return { workatoIframeUrl: url };
  },
  component: WorkatoIframe,
});
